export { default } from './DetailedCarColor';
